import React from "react";
import "./EcoSysSecFive.css";
import laptopBg from "../EcoSysImages/laptop-bg.png";
import titleImg from "../EcoSysImages/title.png";
import { HashLink as Link } from "react-router-hash-link";
export default function EcoSysSecFive() {
  return (
    <section
      className="eco-section-five-bg"
      aria-labelledby="onboarding-heading"
    >
      <div className="eco-section-five-grid" aria-hidden="true" />
      <div
        className="eco-section-five-hero"
        role="img"
        aria-label="Onboarding Complete hero"
      >
        <img
          src={titleImg}
          alt="Onboarding Complete"
          className="eco-section-five-title"
          id="onboarding-heading"
        />
        <div className="eco-section-five-laptop-wrapper">
          <img
            src={laptopBg}
            alt="Laptop interface"
            className="eco-section-five-laptop-bg"
          />
          <div className="eco-section-five-laptop-screen">
            <div className="eco-section-five-modal" label="Onboarding Complete">
              <div
                className="eco-section-five-step"
                label="Progress: step 5 of 5"
              >
                <span>05</span>
                <span className="eco-section-five-step-total">/05</span>
              </div>
              <h1 className="eco-section-five-modal-title">You’re In!</h1>
              <p className="eco-section-five-modal-text">
                Build momentum now — post your first update or grab the starter
                quest <br />
                to earn instant XP.
              </p>
              {/* <button
                className="eco-section-five-cta"
                type="button"
                onClick={() => window.alert("First post flow placeholder")}
              >
                Create My First Post
              </button> */}
              {/* <div className="eco-four-section-button"> */}
              <Link to="/#get3voApp" onClick={() => window.scrollTo(0, 0)}>
                <div className="create-token-btn-eco">
                  <p className="create-eco-btn-text">Create My First Post</p>
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
